<template>
  <div class="mt-5">
    <div class="alertWrap" v-if="showAlert">
      <div class="alert">
        <h2 class="modalTitle tit1 text-center mb-0">銀聯網關支付</h2>
        <label class="my-2" for style="font-size:14px">您的銀行卡的戶主姓名(不能填錯)</label>
        <div class="wallet_name m-0 noIcon">
          <input
            class
            v-model="user_name"
            type="text"
            placeholder="您的銀行卡的戶主姓名"
          />
          <div class="icon">
            <div class="icon_bg">
              <i class="fa fas fa-user"></i>
            </div>
          </div>
        </div>
        <p class="text-danger text-left mt-2" style="font-size:14px">-必須輸入您轉賬銀行卡戶主姓名 ,非姓名無法到賬,恕不負責!</p>
        <button class="btn" :disabled="disabledBtn" @click="sendOrder">確認</button>
      </div>
    </div>
    <div class="flex-column justify-content-start align-items-center" v-if="timeMsg == ''">
    </div>
    <div v-else class="timeMsg">
      <h4 class="tit1" style="color:#007bff !important">{{timeMsg}}</h4>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.m-message-container.is-top-center {
  z-index: 9999 !important;
}
.m-message {
  z-index: 9999 !important;
}
.m-message-container {
  z-index: 9999 !important;
}
.allWrap{
  // background-color: #fff;
}
.alertWrap {
  position: fixed;
  z-index: 90;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .alert {
    width: 345px;
    box-shadow:  0 0 3px 3px rgba(0,0,0,.6);
    height: 345px;
    background-color: white;
    border-radius: 5px;
  }
}
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      order: "",
      timeout: "",
      timeMsg: "",
      showAlert:true,
      user_name:""
    };
  },
  computed: {
    disabledBtn(){
      return this.$store.state.isLoading
    }
  },
  methods: {
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
            if(res.data.data.user_name && res.data.data.view_url && res.data.data.view_url.indexOf(location.origin) == -1){
              location.href = res.data.data.view_url
            }
          } else {
            this.$message({type:'error',message:res.data.message,duration:-1})
            this.timeMsg = res.data.message;
            this.showAlert = false;
            clearInterval(this.timeout);
          }
        });
    },
    sendOrder(){
      this.disabledBtn = true;
      axios
        .post(
          `${process.env.VUE_APP_DEFAULT_SRC}send?transaction_id=${this.$route.query.transaction_id}&user_name=${this.user_name}`,{
            transaction_id:this.$route.query.transaction_id,
            user_name:this.user_name
          }
        )
        .then(res => {
          this.disabledBtn = false;
          if (res.data.code == 0) {
            window.location.href = res.data.data.view_url;
            this.order = res.data.data;
          } else {
            this.showAlert = false
            this.$message({type:'error',message:res.data.message,duration:-1})
            this.timeMsg = res.data.message;
          }
        }).catch(()=>{
          this.disabledBtn = false;
        });
    }
  },
  created() {
    this.getOrder();
    // this.timeout = setInterval(() => this.getOrder(), 10000);
  }
};
</script>
<style lang="scss" scoped>
input {
  background-color: rgb(238,238,238);
  height: 40px;
  border: none;
  color:black
}
button {
  background-color: #007bff;
  color:white
}
.modalTitle{
  color:black !important
}
  .account_name{
    word-break: break-all;
  }
  .timeMsg{
    height: 90vh;
    display: flex;
    align-items: center;
    h4 {
      text-align: center;
    }
  }
  .alertWrap {
    .alert {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .btn {
      margin-top: auto;
    }
    }
  }
</style>

<style lang="scss">
  
body{
  background-color: #fff !important;
}
</style>



